<template>
  <SortSearch default-sort="featured" dimension="FeaturedGraphics" :force-experience="getDesign" />
</template>

<script>
import SortSearch from '@/components/SortSearch';
import { mapGetters } from 'vuex';

export default {
  components: {
    SortSearch
  },
  head() {
    const i18nSeo = this.$seoPlugin({ slash: true });
    return {
      link: [...i18nSeo.link]
    };
  },
  computed: {
    ...mapGetters('experience', ['getDesign'])
  },
  nuxtI18n: {
    paths: {
      en: '/design/featured-graphics',
      es: '/design/graficos-destacados',
      pt: '/design/graficos-em-destaque',
      de: '/design/hervorgehoben-grafiken'
    }
  }
};
</script>
